import lodash from "lodash";
import { FacebookIcon, InstagramIcon, LinkedInIcon, TwitterIcon } from "../../../components/AiMarketingHub/components/Assets/Icons";
import { ScFormat } from "./SocialMediaCaptionSaga";
import { repopulate, setScErrMsg } from "./SocialMediaCaptionUtils";

// TYPES

// export const PROP_DESC_SC_UPDATE_ORDER_ID = "PROP_DESC_SC_UPDATE_ORDER_ID";
export const PROP_DESC_SC_UPDATE_CAPTION_FOR =
    "PROP_DESC_SC_UPDATE_CAPTION_FOR";
export const PROP_DESC_SC_UPDATE_TOPIC = "PROP_DESC_SC_UPDATE_TOPIC";
export const AI_DESC_EG_HANDLE_REPOPULATE_SC_CAPTION = "AI_DESC_EG_HANDLE_REPOPULATE_SC_CAPTION";
export const PROP_DESC_SC_UPDATE_OTHER_TOPIC =
    "PROP_DESC_SC_UPDATE_OTHER_TOPIC";
export const PROP_DESC_SC_UPDATE_DETAILS = "PROP_DESC_SC_UPDATE_DETAILS";
export const PROP_DESC_SC_UPDATE_CAPTION_ISEDITING =
    "PROP_DESC_SC_UPDATE_CAPTION_ISEDITING";
export const PROP_DESC_SC_UPDATE_CAPTION = "PROP_DESC_SC_UPDATE_CAPTION";
export const AI_DESC_SC_FETCH_CAPTION = "AI_DESC_SC_FETCH_CAPTION";
export const AI_DESC_SC_UNDO_CAPTION = "AI_DESC_SC_UNDO_CAPTION";
export const AI_DESC_SC_UPDATE_ACTION_CAPTION =
    "AI_DESC_SC_UPDATE_ACTION_CAPTION";
export const AI_DESC_SC_GENERATE_CAPTION = "AI_DESC_SC_GENERATE_CAPTION";
export const AI_DESC_SC_REGENERATE_CAPTION = "AI_DESC_SC_REGENERATE_CAPTION";
export const AI_DESC_SC_HANDLE_ACTION_CAPTION =
    "AI_DESC_SC_HANDLE_ACTION_CAPTION";
export const AI_DESC_SC_UPDATE_PAGE_TYPE = "AI_DESC_SC_UPDATE_PAGE_TYPE";
export const AI_DESC_SC_HANDLE_DD_OPEN = "AI_DESC_SC_HANDLE_DD_OPEN";
export const AI_DESC_SC_HANDLE_SEVER_BUSY_POPUP = "AI_DESC_SC_HANDLE_SEVER_BUSY_POPUP";
export const PROP_DESC_SC_CLEAR = "PROP_DESC_SC_CLEAR";

// ACTIONS

// export const updateScOrderId = (payload) => ({
//     type: PROP_DESC_SC_UPDATE_ORDER_ID,
//     payload,
// });

export const handleScTopicDdOpen = (payload) => ({
    type: AI_DESC_SC_HANDLE_DD_OPEN,
    payload,
});

export const updateScCaptionFor = (payload) => ({
    type: PROP_DESC_SC_UPDATE_CAPTION_FOR,
    payload,
});

export const updateScOtherTopic = (payload) => ({
    type: PROP_DESC_SC_UPDATE_OTHER_TOPIC,
    payload,
});

export const updateScTopic = (payload) => ({
    type: PROP_DESC_SC_UPDATE_TOPIC,
    payload,
});

export const updateScDetails = (payload) => ({
    type: PROP_DESC_SC_UPDATE_DETAILS,
    payload,
});

export const updateScDescIsEditing = (payload) => ({
    type: PROP_DESC_SC_UPDATE_CAPTION_ISEDITING,
    payload,
});

export const updateScDesc = (payload) => ({
    type: PROP_DESC_SC_UPDATE_CAPTION,
    payload,
});

export const fetchScDesc = (payload) => ({
    type: AI_DESC_SC_FETCH_CAPTION,
    payload,
});

export const handleScDescUndo = (payload) => ({
    type: AI_DESC_SC_UNDO_CAPTION,
    payload,
});

export const updateActionScDesc = (payload) => ({
    type: AI_DESC_SC_UPDATE_ACTION_CAPTION,
    payload,
});

export const updateScPageType = (payload) => ({
    type: AI_DESC_SC_UPDATE_PAGE_TYPE,
    payload,
});

export const handleRepopulateSc = (payload) => ({
    type: AI_DESC_EG_HANDLE_REPOPULATE_SC_CAPTION,
    payload,
});

export const clearScDetails = (payload) => ({
    type: PROP_DESC_SC_CLEAR,
    payload,
});

export const handleScSeverBusyPopup = (payload) => ({
    type: AI_DESC_SC_HANDLE_SEVER_BUSY_POPUP,
    payload,
});

// Actions to trigger saga generators

export const generateScDesc = (payload) => ({
    type: AI_DESC_SC_GENERATE_CAPTION,
    payload,
});

export const regenerateScDesc = (payload) => ({
    type: AI_DESC_SC_REGENERATE_CAPTION,
    payload,
});

export const handleActionScDesc = (payload) => ({
    type: AI_DESC_SC_HANDLE_ACTION_CAPTION,
    payload,
});

// REDUCER

export const INITIAL_STATE = {
    order_id: `${Date.now() + Math.floor(Math.random() * 100)}`,
    captionFor: {
        socialMediaOptions: [
            {
                title: "Facebook",
                icon: <FacebookIcon/>,
            },
            {
                title: "Instagram",
                icon: <InstagramIcon/>,
            },
            {
                title: "Twitter",
                icon: <TwitterIcon/>,
            },
            {
                title: "Linkedin",
                icon: <LinkedInIcon/>,
            },
        ],
        selectedSocialMediaOption: "Facebook",
    },
    topic: {
        title:"Select topic",
        defaultTitle:"Select topic",
        dropDownList: [
            "Just sold",
            "Open house(s)",
            "Market update",
            "New listing(s)",
            "Throwback post",
            "Before & after",
            "Team highlights",
            "Tips for buyers",
            "Tips for sellers",
            "Home of the week",
            "Community events",
            "Neighborhood guide",
            "Property video tour",
            "Partnership spotlight",
            "Financial tips",
            "Home maintenance tips",
            "Design & renovation tips",
            "Home value maximization tips",
            "Holiday/festival greeting",
            "Other topic",
        ],
        isSelectedOthers: false,
        selectedItem: "",
        otherTopic: "",
        isOpen:false,
    },
    details: "",
    captionGenerated: [
        // {
        //     status: "Just now",
        //     generatedDesc:
        //         "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
        //         editedDesc: "",
        //     isEditing: false,
        //     isEdited: false,
        //     liked: null,
        //     generated_at: Date.now(),
        // },
    ],
    repopulate:false,
    isGenCaptionBtnHidden: false,
    isGenCaptionBtnDisabled: true,
    isCaptionGenerating: false,
    errMsg: "Please fill the required fields.",
    pageType: "Caption Generation",
    popups:{
        busyServer:{
            show:false,
        }
    },
};

const SocialMediaCaptionReducer = (
    state = lodash.cloneDeep(INITIAL_STATE),
    action
) => {
    switch (action.type) {
        case PROP_DESC_SC_CLEAR: {
            let temp_state = lodash.cloneDeep(INITIAL_STATE);
            temp_state.order_id = `${
                Date.now() + Math.floor(Math.random() * 100)
            }`;
            return { ...temp_state };
        }
        // case PROP_DESC_SC_UPDATE_ORDER_ID: {
        //     let temp_state = { ...state };
        //     temp_state.order_id=Date.now() + Math.floor(Math.random() * 100)
        //     return {
        //         ...temp_state,
        //     };
        // }
        case AI_DESC_SC_HANDLE_DD_OPEN: {
            const { isOpen } = action.payload;
            let temp_state = { ...state };
            temp_state.topic.isOpen=isOpen
            return {
                ...temp_state,
            };
        }
        case PROP_DESC_SC_UPDATE_CAPTION_FOR: {
            const { socialMediaOption } = action.payload;
            let temp_state = lodash.cloneDeep(INITIAL_STATE);
            temp_state.order_id = `${Date.now() + Math.floor(Math.random() * 100)}`;
            temp_state["captionFor"]["selectedSocialMediaOption"] =
                socialMediaOption;
            return {
                ...temp_state,
            };
        }
        case PROP_DESC_SC_UPDATE_TOPIC: {
            const { topic } = action.payload;
            let temp_state = { ...state };
            let topicObj = temp_state["topic"];
            // if (topicObj["selectedItem"] == topic){
            //     topicObj["selectedItem"] = "";
            //     topicObj["title"] = topicObj["defaultTitle"];
            //     topicObj["isSelectedOthers"] = false;
            // }else{
                if (topic === "Other topic") {
                    topicObj["isSelectedOthers"] = true;
                } else {
                    topicObj["isSelectedOthers"] = false;
                }
                topicObj["selectedItem"] = topic;
                topicObj["title"]=topic
            // }
            temp_state.isGenCaptionBtnHidden = false;
            setScErrMsg(temp_state);
            return {
                ...temp_state,
            };
        }
        case PROP_DESC_SC_UPDATE_OTHER_TOPIC: {
            const { otherTopic } = action.payload;
            let temp_state = { ...state };
            let topicObj = temp_state["topic"];
            topicObj["otherTopic"] = otherTopic;
            temp_state.isGenCaptionBtnHidden = false;
            setScErrMsg(temp_state);
            return {
                ...temp_state,
            };
        }
        case PROP_DESC_SC_UPDATE_DETAILS: {
            const { details } = action.payload;
            let temp_state = { ...state };
            temp_state["details"] = details;
            temp_state.isGenCaptionBtnHidden = false;
            setScErrMsg(temp_state);
            return {
                ...temp_state,
            };
        }
        case PROP_DESC_SC_UPDATE_CAPTION_ISEDITING: {
            const { isEditing, descInd } = action.payload;
            let temp_state = { ...state };
            let capGen = temp_state.captionGenerated;
            // let genDesc = capGen[descInd]["generatedDesc"];
            // let edDesc = capGen[descInd]["editedDesc"];
            // if (edDesc !== genDesc && edDesc!=="") {
            //     capGen[descInd]["isEdited"] = true;
            // }else{
            //     capGen[descInd]["isEdited"] = false;
            // }
            capGen[descInd]["isEditing"] = isEditing;
            return {
                ...temp_state,
            };
        }
        case PROP_DESC_SC_UPDATE_CAPTION: {
            const { descInd, desc } = action.payload;
            let temp_state = { ...state };
            let capGen = temp_state.captionGenerated;
            capGen[descInd]["editedDesc"] = desc;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_SC_FETCH_CAPTION: {
            let temp_state = { ...state };
            const {captions}=action.payload
            temp_state.captionGenerated = captions;
            temp_state.isGenCaptionBtnHidden = true;
            temp_state["isCaptionGenerating"] = false;
            temp_state["pageType"] = "Generated Section";
            temp_state.repopulate=false
            return {
                ...temp_state,
            };
        }
        case AI_DESC_SC_UPDATE_ACTION_CAPTION: {
            const { descInd, actionInfo,isEdited } = action.payload;
            let temp_state = { ...state };
            let capGen = temp_state.captionGenerated;
            Object.keys(actionInfo).forEach((actKey) => {
                capGen[descInd][actKey] = actionInfo[actKey];
            });
            capGen[descInd]["isEdited"] = isEdited;
            capGen[descInd]["isEditing"] = false;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_SC_UNDO_CAPTION: {
            const { descInd } = action.payload;
            let temp_state = { ...state };
            let capGen = temp_state.captionGenerated;
            capGen[descInd]["editedDesc"] =
                capGen[descInd]["description_generated"];
            capGen[descInd]["isEditing"] = false;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_SC_GENERATE_CAPTION: {
            let temp_state = { ...state };
            temp_state["isCaptionGenerating"] = true;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_SC_REGENERATE_CAPTION: {
            let temp_state = { ...state };
            temp_state["isCaptionGenerating"] = true;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_SC_UPDATE_PAGE_TYPE: {
            const { pageType } = action.payload;
            let temp_state = { ...state };
            temp_state.pageType = pageType;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_EG_HANDLE_REPOPULATE_SC_CAPTION: {
            const { data } = action.payload;
            let temp_state = { ...state };
            repopulate(temp_state,data)
            setScErrMsg(temp_state);
            return {
                ...temp_state,
            };
        }
        case AI_DESC_SC_HANDLE_SEVER_BUSY_POPUP: {
            let temp_state = { ...state };
            const {isShow} = action.payload
            temp_state.popups.busyServer.show=isShow
            return {
                ...temp_state,
            };
        }
        default:
            return state;
    }
};

export default SocialMediaCaptionReducer;
